import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";

import styles from "./index.module.css";

import GifAnimation from "../atoms/GifAnimation";
import useIOSTouch from "../atoms/useIOSTouch";

import TITLE from "../../assets/noise/texts/HEADER/DISCO.gif";
import JPEN from "../../assets/noise/texts/HEADER/JP_EN.gif";

const Header = ({ className, onSelect, onLang, lang, history, ...props }) => {
  const handleClick = e => {
    onSelect && onSelect(e);
  };
  const handleLanguage = e => {
    onLang && onLang(e);
  };

  // line height problem for GIF crop
  // https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
  const isMac = ["MacIntel", "Mac68K", "MacPPC", "iPhone", "iPod", "iPad"].some(
    v => navigator.platform === v
  );

  const handleIOSTouch = e => {
    history && history.push("/");
  };

  const linkRef = useRef();
  useIOSTouch(linkRef, handleIOSTouch);

  return (
    <div className={`${styles.container} ${className}`} {...props}>
      <div className={styles.left} onClick={() => handleClick("main")}>
        <Link to="/" innerRef={linkRef} className={styles.link}>
          <GifAnimation gifSrc={TITLE} className={styles.titleGif}>
            <h1 className={styles.title}>DISCO</h1>
          </GifAnimation>
        </Link>
      </div>

      <div className={styles.mid} />

      <div className={styles.right}>
        <h3 className={styles.jpenPC}>
          <GifAnimation
            gifSrc={JPEN}
            className={styles.jpGif}
            style={{ lineHeight: isMac ? "21px" : "19px" }}
          >
            <span
              onClick={() => handleLanguage("jp")}
              style={{ opacity: lang === "jp" ? 1 : 0.5, margin: "0 5px" }}
            >
              JP
            </span>
          </GifAnimation>
          <span> / </span>
          <GifAnimation
            gifSrc={JPEN}
            className={styles.enGif}
            style={{ lineHeight: isMac ? "21px" : "19px" }}
          >
            <span
              onClick={() => handleLanguage("en")}
              style={{ opacity: lang === "en" ? 1 : 0.5, margin: "0 5px" }}
            >
              EN
            </span>
          </GifAnimation>
        </h3>

        <GifAnimation gifSrc={JPEN} className={styles.jpenGif}>
          <h3 className={styles.jpenMobile}>
            <span
              onClick={() =>
                lang === "en" ? handleLanguage("jp") : handleLanguage("en")
              }
            >
              {lang === "en" ? "JP" : "EN"}
            </span>
          </h3>
        </GifAnimation>
      </div>
    </div>
  );
};

export default Header;
